import { NgModule } from '@angular/core';
import { Autosize } from './autosize/autosize';
import { CreditDebitCardDirective, ExpiryDateDirective } from './cardnumber/cardnumber';
@NgModule({
	declarations: [Autosize,CreditDebitCardDirective,ExpiryDateDirective],
	imports: [],
	exports: [Autosize,CreditDebitCardDirective,ExpiryDateDirective]
})
export class DirectivesModule {}



// WEBPACK FOOTER //
// ./src/directives/directives.module.ts